let Campaign = {

    loading: false,
    picking: false,

    initialize: () => {
        if (!Campaign.loading) {
            Campaign.loading = true;
            let container = document.getElementById('campaign_container');
            Api.get('/campaign/get', {}, (r) => {
               if (r.success) {
                    container.innerHTML = `
                        <div class="box box-big box-green">
                            <div class="head">${r.data?.title} <span class="glyphicons glyphicons-flag"></span></div>
                            <div class="body text">${r.data?.description}</div>
                            <div class="body flex" style="justify-content: space-around;align-items: center;">
                                <div style="display: flex;flex-direction: column;gap: 10px;align-items: center">
                                    <div class="achievement exhibitor" rel="tooltip" data-name="${r.data?.choices?.one?.name}" data-description="${r.data?.choices?.one?.description}" style="background-image:url(/images/hexagon_white.png), url(${r.data?.choices?.one?.image});width: 100px;height: 100px;margin: 0 0 -4px;float: left;background-size: 100px 100px,100px 100px;"></div>
                                    <button id="campaign_pick_one" class="button blue large big" onclick="Campaign.pick(1);">${r.data.labels.one}</button>
                                </div>
                                <div style="display: flex;flex-direction: column;gap: 10px;align-items: center">
                                    <div class="achievement exhibitor" rel="tooltip" data-name="${r.data?.choices?.second?.name}" data-description="${r.data?.choices?.second?.description}" style="background-image:url(/images/hexagon_white.png), url(${r.data?.choices?.second?.image});width: 100px;height: 100px;margin: 0 0 -4px;float: left;background-size: 100px 100px,100px 100px;"></div>
                                    <button id="campaign_pick_two" class="button blue large big" onclick="Campaign.pick(2);">${r.data.labels.second}</button>
                                </div>
                            </div>
                        </div>
                    `;
               }
            });
            Campaign.loading = false;
        }
    },

    pick: (option) => {
        if (!Campaign.picking) {
            Campaign.picking = true;
            let btn_one = document.getElementById("campaign_pick_one");
            let btn_two = document.getElementById("campaign_pick_two");
            let container =  document.getElementById('campaign_container');
            btn_one.disabled = true;
            btn_two.disabled = true;
            Api.post('/campaign/pick', {option}, (r) => {
                if (r.success) {
                    Alert.push([{type: 'success', text: '¡Enhorabuena! Has seleccionado un bando de forma exitosa. Revisa tus logros para lucir el logro respectivo.', icon: 'check'}]);
                    container.remove();
                } else {
                    switch (r.error.identifier) {
                        case 'invalid_option_selected':
                            Alert.push([{type: 'danger', text: '¡Oops! La opción seleccionada no es un bando válido. Intentalo de nuevo.', icon: 'triangle-alert'}]);
                            break;
                        case 'already_participate':
                            Alert.push([{type: 'danger', text: '¡Oops! Ya has seleccionado un bando previamente.', icon: 'triangle-alert'}]);
                            container.remove();
                            break;
                        case 'deadline_is_finish':
                            Alert.push([{type: 'danger', text: '¡Oops! La selección de bandos ya ha finalizado.', icon: 'triangle-alert'}]);
                            container.remove();
                            break;
                        case 'campaign_is_not_ready':
                            Alert.push([{type: 'danger', text: '¡Oops! La selección de bandos no está disponible temporalmente.', icon: 'triangle-alert'}]);
                            break;
                    }
                }
            });
            btn_one.disabled = false;
            btn_two.disabled = false;
            Campaign.picking = false;
        }
    }

}
